/* Component Dependencies */
var destinationTitleTemplate = require('templates/destinationTitle.hbs');
var destinationTitleBreadCrumbTemplate = require('templates/destinationTitle-breadcrumb.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'destinationTitle',
    template: {
        'destinationTitle': destinationTitleTemplate,
        'destinationTitle-breadcrumb': destinationTitleBreadCrumbTemplate
    }
});